module.exports = __webpack_public_path__ + "static/img/S200_d.0c84068.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/devices/S200_d.png
// module id = FAdJ
// module chunks = 0